import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { navigate } from "@reach/router";
import { QueueLaneTiles } from "./QueueLaneTiles";
import { QueueWorkItemRow } from "./QueueWorkItemRow";
import { filterQueueByLane, taskManagerHref } from "./queueModel";

export function OpenTasksPanel(props) {
  var summary = props.summary || {};
  var items = props.items || [];
  var previewLane = "new_orders";
  if (summary.exceptions > 0) previewLane = "exceptions";
  else if (summary.delivery_change > 0) previewLane = "delivery_change";
  else if (summary.due_today > 0) previewLane = "due_today";

  var previewItems = filterQueueByLane(items, previewLane).slice(0, 5);
  if (previewItems.length === 0) {
    previewItems = items
      .filter(function (item) {
        return item.lane !== "completed";
      })
      .slice(0, 5);
  }

  return (
    <Box data-testid="open-tasks-panel">
      <QueueLaneTiles
        compact
        loading={Boolean(props.loading)}
        summary={summary}
        onSelect={function (lane) { navigate(taskManagerHref("", "", lane)); }}
      />

      {summary.urgent > 0 ? (
        <Box
          data-testid="open-tasks-callout"
          sx={{
            mt: 1,
            px: 1.25,
            py: 0.75,
            borderRadius: "8px",
            backgroundColor: "#fff7ed",
            border: "1px solid #fdba74",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Typography sx={{ color: "#9a3412", fontSize: 12, fontWeight: 600 }}>
            {summary.urgent} {summary.urgent === 1 ? "task needs" : "tasks need"} action now.
          </Typography>
          <Button
            size="small"
            variant="contained"
            onClick={function () { navigate(taskManagerHref("", "", previewLane)); }}
            sx={{
              textTransform: "none",
              backgroundColor: "#c2410c",
              "&:hover": { backgroundColor: "#9a3412" },
              minHeight: 28,
              py: 0,
              px: 1.25,
              fontSize: 12,
              flexShrink: 0,
            }}
          >
            Review now
          </Button>
        </Box>
      ) : null}

      {previewItems.length > 0 ? (
        <Box sx={{ mt: 1.25, display: "flex", flexDirection: "column", gap: 1 }}>
          {previewItems.map(function (item) {
            return (
              <QueueWorkItemRow
                key={item.id}
                item={item}
                dense
                onOpen={function () {
                  navigate(taskManagerHref(item.id, item.type, item.lane));
                }}
              />
            );
          })}
        </Box>
      ) : null}
    </Box>
  );
}



// WEBPACK FOOTER //
// ./src/components/workflowQueue/OpenTasksPanel.js